import { useCallback, useEffect, useState } from 'react';
import api from '../../../services/api';
import type { PortfolioStrategy } from './rmfLabels';

/** Lista as estratégias de portfólio (compartilhadas) da conta Google Ads. */
export const usePortfolioStrategies = (enabled: boolean) => {
  const [portfolios, setPortfolios] = useState<PortfolioStrategy[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/campaigns/google/portfolio-strategies');
      setPortfolios(Array.isArray(res.data?.data) ? res.data.data : []);
      setError(null);
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'erro');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return { portfolios, loading, error, reload };
};

export default usePortfolioStrategies;
